import React from "react";
import {
  ProductCard,
  Button,
  IntersectionAnimation,
  SliceConfig
} from "~components";
import cn from "classnames";
import * as styles from "./styles.module.scss";

const ProductCards = ({
  heading,
  linkToAllProducts,
  productIds,
  sliceConfig,
  className
}) => (
  <SliceConfig config={sliceConfig}>
    <div className={cn(styles.container, className)}>
      <h2 className={cn(`h2`, styles.heading)}>{heading}</h2>

      {/* Mobile Carousel - Lauren doesn't want carousel on mobile */}
      {/* <SwiperCarousel className={styles.carousel}>
        {productIds?.map((productId, i) => (
          <ProductCard productId={productId} key={i} />
        ))}
      </SwiperCarousel> */}

      {/* Desktop Grid */}

      <div className={styles.grid}>
        {productIds?.map((productId, i) => (
          <IntersectionAnimation animation="fadeGrow" key={i} delay={i * 100}>
            <ProductCard productId={productId} />
          </IntersectionAnimation>
        ))}
      </div>
      {linkToAllProducts && (
        <div className={styles.buttonContainer}>
          <Button to="/products" variant="secondary">
            View all products
          </Button>
        </div>
      )}
    </div>
  </SliceConfig>
);

export default ProductCards;
